import React from 'react'
import { removeSpecialChars } from '../../utils'
import { Flex } from 'chemistry'

const highlightTerm = (text, term) => {
  const termIndex = text.search(new RegExp(removeSpecialChars(term), 'i'))
  const start = termIndex > 0 ? text.substring(0, termIndex) : null
  const termPart = text.substring(termIndex, termIndex + term.length)
  const end = termIndex + term.length < text.length ? text.substring(termIndex + term.length) : null
  return [start, termPart, end]
}

const Option = ({
  term = '',
  link,
  text = '',
  count = '',
  imageUrl,
  isSelected,
  onSelect,
  pageMode,
  showSuggestionImage,
  showSuggestionCount
}) => {
  const [startPart, termPart, endPart] = highlightTerm(text, term)
  const optionProps = {}
  if (isSelected) optionProps.className = 'sfe-active'

  return (
    <li
      onMouseDown={e => {
        onSelect(e, link, text, pageMode)
      }}
      {...optionProps}
    >
      {showSuggestionImage || showSuggestionCount ? (
        <a href={link} className='sfe-search-dropdown-list-item-link'>
          {/* spans needed, otherwise fragment crashes because of Google Translate DOM mutations https://github.com/facebook/react/issues/11538 */}
          <Flex justify='space-between' alignItems='center'>
            <Flex align='center'>
              {showSuggestionImage && imageUrl && <img src={imageUrl?.replace('.png', `.webp`)} alt='' />}
              <span>{startPart}</span>
              <strong>{termPart}</strong>
              <span>{endPart}</span>
            </Flex>
            {showSuggestionCount && <strong>{count}</strong>}
          </Flex>
        </a>
      ) : (
        <a href={link} className='sfe-search-dropdown-list-item-link'>
          <span>{startPart}</span>
          <strong>{termPart}</strong>
          <span>{endPart}</span>
        </a>
      )}
    </li>
  )
}

export default Option
